import { AIR_TRANSPORT_MODE, MODE_OF_TRANSPORT_RAIL } from 'shared/ncts/common/constants'
import { removePrefix, TRANSPORT_MODE_CODE_PREFIX } from 'shared/ncts/common/classifier-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0532Validator = {
  validateConveyanceReferenceNumberRequirement: ({
    security,
    borderModeOfTransport,
    specificCircumstanceIndicator,
  }: {
    security: string
    borderModeOfTransport: string
    specificCircumstanceIndicator?: string
  }): RuleResult => {
    const borderModeOfTransportWithoutPrefix = removePrefix(borderModeOfTransport, TRANSPORT_MODE_CODE_PREFIX) ?? ''

    if (['1', '2', '3'].includes(security) && borderModeOfTransportWithoutPrefix === AIR_TRANSPORT_MODE) return 'REQUIRED'

    return specificCircumstanceIndicator === MODE_OF_TRANSPORT_RAIL ? 'REQUIRED' : 'OPTIONAL'
  },
}

export default C0532Validator
